import { useState, useCallback, useRef } from 'react';
import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';

export const useMentionSearch = () => {
  const [suggestions, setSuggestions] = useState([]);
  const debounceTimeoutRef = useRef(null);

  const searchCollaborators = useCallback(async (query) => {
    if (!query || query.length < 1) {
      setSuggestions([]);
      return;
    }
    
    try {
      const response = await http.post('/ColaboradorLookup/Search', {
        text: query,
        somenteAtivos: true
      });

      if (response.data?.list && Array.isArray(response.data.list)) {
        setSuggestions(response.data.list);
      } else {
        setSuggestions([]);
      }
    } catch (error) {
      errorHandler(error);
      setSuggestions([]);
    }
  }, []);

  const searchWithDebounce = useCallback((query, delay = 300) => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    
    debounceTimeoutRef.current = setTimeout(() => {
      searchCollaborators(query);
    }, delay);
  }, [searchCollaborators]);

  const clearSuggestions = useCallback(() => {
    setSuggestions([]);
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
  }, []);

  return {
    suggestions,
    searchWithDebounce,
    clearSuggestions
  };
};

